import { Component, type ErrorInfo, type ReactNode } from "react";
import { crash } from "@/platform/crash";
import { track } from "@/services/telemetry";

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    track("error.react", { message: error.message, stack: info.componentStack ?? "" });
    crash.get().captureException(error, { kind: "react", stack: info.componentStack ?? "" });
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="fatal">
          <h1>Something broke.</h1>
          <pre>{this.state.error.message}</pre>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
